/**
 * Query-string builder for `GET /messages`.
 *
 * The harness runs express-openapi-validator with
 * `allowUnknownQueryParameters: false`, so ANY param the contract does not
 * declare is a 400 — a cache-buster, a stray `tenantId`, anything. Building the
 * string in one audited place is what keeps that from happening by accident.
 */
import type { Hl7MessageFilter } from './types'

/** The contract's maximum. The server clamps above this; asking for more is pointless. */
export const PAGE_LIMIT = 200

export function buildMessagesQuery(filter: Hl7MessageFilter): string {
  const params = new URLSearchParams()

  if (filter.direction) params.set('direction', filter.direction)
  // The param is `channel`, not `channelId` — the request body uses channelId,
  // the query does not, and mixing them up costs a 400.
  if (filter.channel) params.set('channel', filter.channel)
  if (filter.type) params.set('type', filter.type)
  if (filter.since) params.set('since', filter.since)
  // sinceSeq 0 means "no cursor yet". Sending it would be harmless but dishonest,
  // and it makes the first request distinguishable in a network log.
  if (filter.sinceSeq !== undefined && filter.sinceSeq > 0) {
    params.set('sinceSeq', String(filter.sinceSeq))
  }
  if (filter.limit !== undefined) params.set('limit', String(filter.limit))

  const query = params.toString()
  return query ? `?${query}` : ''
}
